import { render, staticRenderFns } from "./ElevatorList.vue?vue&type=template&id=5ffeb8a9&scoped=true"
import script from "./ElevatorList.vue?vue&type=script&lang=js"
export * from "./ElevatorList.vue?vue&type=script&lang=js"
import style0 from "./ElevatorList.vue?vue&type=style&index=0&id=5ffeb8a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffeb8a9",
  null
  
)

export default component.exports